import { useQuery } from '@redwoodjs/web';
import { GetFinanceConfiguration } from 'types/graphql';

export const GET_FINANCE_CONFIGURATION = gql`
  query GetFinanceConfiguration {
    financeConfiguration {
      id
      defaultAssetsAccountId
      defaultLiabilitiesAccountId
      defaultExpensesAccountId
      defaultIncomeAccountId
      autoCloseFractionalBalances
      fractionalBalanceThresholdCents
      fractionalBalanceAdjustmentAccountId
    }
  }
`;

export default function useFinanceConfiguration(): GetFinanceConfiguration | null {
  const { data, error } = useQuery(GET_FINANCE_CONFIGURATION, { fetchPolicy: 'cache-first' });

  if (error) {
    return null;
  }

  return data?.financeConfiguration ?? null;
}
